import { render, staticRenderFns } from "./ChangguanNearestHotelListBlock.vue?vue&type=template&id=3686f776&scoped=true"
import script from "./ChangguanNearestHotelListBlock.vue?vue&type=script&lang=js"
export * from "./ChangguanNearestHotelListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3686f776",
  null
  
)

export default component.exports